import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditProduct() {
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    description: "",
    image: "",
    price: 0,
    stockQuantity: 0,
    discountPrice: 0,
    quantity: 0,
    minOrderQuantity: 1,
    maxOrderQuantity: 5,
    mealType: "",
    includes:"",
    tags:""
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const location = useLocation();
  const data = location.state.data;
  const catgId = data?.categoryId?._id || ""
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setFormData({
      name: data.name,
      title: data.title,
      description: data.description,
      price: data.price,
      stockQuantity: data.stockQuantity,
      discountPrice: data.discountPrice,
      quantity: data.quantity,
      minOrderQuantity: data.minOrderQuantity ?? 1,
      maxOrderQuantity: data.maxOrderQuantity ?? 5,
      subCategoryId: data?.subCategoryId?._id || "",
      mealType: data?.mealType || "",
      includes: data?.includes?.join(",") || "",
      tags: data?.tags?.join(",") || ""
    });
    setPreviewImage(`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.image}`);
  }, []);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    // if (name === "image") {
    //   setFormData({ ...formData, image: e.target.files[0] });
    //   return;
    // }

    if (name === "image") {
      const file = e.target.files[0];
      setFormData({ ...formData, image: file });
      setPreviewImage(URL.createObjectURL(file)); // 👈 preview
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("title", formData.title);
      formdata.append("description", formData.description);
      formdata.append("price", formData.price);
      formdata.append("stockQuantity", formData.stockQuantity);
      formdata.append("discountPrice", formData.discountPrice);
      formdata.append("minOrderQuantity", formData.minOrderQuantity);
      formdata.append("maxOrderQuantity", formData.maxOrderQuantity);
      formdata.append("productId", id);
      if (formData.image) {
        formdata.append("image", formData.image);
      }
      if (formData.quantity) {
        formdata.append("quantity", formData.quantity);
      }

      if (formData.subCategoryId && (catgId === "6807cb83f6420596e1e7d2a9" || catgId === "6818ed021071326265af20cd")) {
        formdata.append("subCategoryId", formData.subCategoryId);
      }

      if (formData.mealType && catgId === "6818ed021071326265af20cd") {
        formdata.append("mealType", formData.mealType);
        formdata.append("tags", formData.tags);
        formdata.append("includes", formData.includes);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/product/edit-product`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        navigate(-1);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit product. Please try again.", error);
    }
    setDisableBtn(false);
  };

  const [productOptions, setProductOptions] = useState([]);
  const [mealtypes, setMealtypes] = useState([]);

  useEffect(() => {
    const fetchProductsCategory = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
        };

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/subCategory/by-categoryId/${catgId}`,
          { headers }
        );

        setProductOptions(response.data?.result?.subCategories);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    const fetchMealTypes = async () => {
      try {

        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
        };

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/mealtype/by-type/${catgId}`,
          { headers }
        );

        setMealtypes(response.data?.result?.types);

      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };


    if (catgId) {
      fetchProductsCategory();
      fetchMealTypes();
    }

  }, [catgId]);

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Edit Product</h2>

              <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Back
              </button>

            </div>

            {
              (catgId === "6807cb83f6420596e1e7d2a9" || catgId === "6818ed021071326265af20cd") && <div className="mt-4">
                <label htmlFor="" className="text-sm">
                  Sub Category
                </label>{" "}
                <br />
                <select
                  className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                  name="subCategoryId"
                  value={formData.subCategoryId}
                  onChange={handleInputChange}
                  required
                >
                  <option value=""> Sub Category</option>
                  {productOptions.map((product) => (
                    <option key={product._id} value={product._id}>
                      {product.name}
                    </option>
                  ))}
                </select>
              </div>
            }

            {
              catgId === "6818ed021071326265af20cd" && <div className="mt-4">
                <label htmlFor="" className="text-sm">
                  Meal Type
                </label>{" "}
                <br />
                <select
                  className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                  name="mealType"
                  value={formData.mealType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Meal Type</option>
                  {mealtypes?.map((type) => (
                    <option key={type._id} value={type.title}>
                      {type.title}
                    </option>
                  ))}
                </select>
              </div>
            }

            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Product Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Category Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Product Title
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Category Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Product Description
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Category Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                {
                  catgId === "67deed42f56f3e22dc5b82e8" && <div className="mt-4">
                    <label htmlFor="" className="text-sm">
                      Quantity (In Litres)
                    </label>{" "}
                    <br />
                    <input
                      type="number"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                      placeholder="Enter Amount (In Litres)"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleInputChange}
                      min={0}
                      required
                    />
                  </div>
                }
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Stock Quantity
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Product Quantity"
                    name="stockQuantity"
                    value={formData.stockQuantity}
                    onChange={handleInputChange}
                    min={0}
                    required
                  />
                </div>
                <div className="mt-4 flex">
                  <div className="w-1/2 pr-2">
                    <label htmlFor="" className="text-sm">
                      Min Order Quantity
                    </label>{" "}
                    <br />
                    <input
                      type="number"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                      placeholder="Enter Min Order Quantity"
                      name="minOrderQuantity"
                      value={formData.minOrderQuantity}
                      onChange={handleInputChange}
                      min={1}
                      required
                    />
                  </div>
                  <div className="w-1/2 pl-2">
                    <label htmlFor="" className="text-sm">
                      Max Order Quantity
                    </label>{" "}
                    <br />
                    <input
                      type="number"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                      placeholder="Enter Max Order Quantity"
                      name="maxOrderQuantity"
                      value={formData.maxOrderQuantity}
                      onChange={handleInputChange}
                      min={1}
                      required
                    />
                  </div>
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Original Price
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Product Price"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Discounted Price
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Discounted Price"
                    name="discountPrice"
                    value={formData.discountPrice}
                    onChange={handleInputChange}
                    min={0}
                    required
                  />
                </div>

                
                {
                  catgId === "6818ed021071326265af20cd" ? (
                    <div className="mt-4 flex">
                      {/* Includes Field */}
                      <div className="w-1/2 pr-2">
                        <label htmlFor="" className="text-sm">
                          Includes
                        </label>
                        <br />
                        <input
                          type="text"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                          placeholder="Food, Salad"
                          name="includes"
                          value={formData.includes}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      {/* Tags Field */}
                      <div className="w-1/2 pl-2">
                        <label htmlFor="" className="text-sm">
                          Tags
                        </label>
                        <br />
                        <input
                          type="text"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                          placeholder="Fresh, New"
                          name="tags"
                          value={formData.tags}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  ) : null
                }

                {/* Product Image */}
                <div className="mt-4">
                  <label htmlFor="categoryImage" className="text-sm">
                    Product Image
                  </label>

                  <br />
                  {/* <img
                    src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.image}`}
                    className="h-[100px] w-[120px] rounded-lg"
                    alt=""
                  /> */}
                  {previewImage && (
                    <img
                      src={previewImage}
                      className="h-[100px] w-[120px] rounded-lg object-cover mb-2"
                      alt="Preview"
                    />
                  )}
                  <br />
                  <input
                    type="file"
                    className="block w-full text-sm text-slate-800 file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
                    placeholder="Choose Picture"
                    name="image"
                    onChange={handleInputChange}
                  // required
                  />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i>{" "}
                    {disableBtn ? "Updating ..." : "Edit Product"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
